// PayslipPdf.js
import { Document, Page, Text, View } from "@react-pdf/renderer";
import dayjs from "dayjs";
import React from "react";

// import ReportHeader from "../report-header";
import { numberToWords } from "../../../helper/numberToWords";
import ReportHeader1 from "../report-header1";
import { fonts, reportStyles } from "../report-style";
import { formatIndianCurrency, formatToCustomDate } from "../../../utils/common";
import { convertMinutesToHours } from "../../payroll/utils";
import { logger } from "../../../utils/logger";
// import { formatIndianCurrency } from "../../../utils/common";
fonts();

const PayslipPdf = ({ payslipReportData }) => {
  // const [ipAddress, setIpAddress] = useState("");

  // useEffect(() => {
  //   fetch("https://api64.ipify.org?format=json")
  //     .then((response) => response.json())
  //     // .then((data) => setIpAddress(data.ip))
  //     .catch((error) => console.error("Error fetching IP:", error));
  // }, []);

  // const totalEarnings =
  //   (parseFloat(payslipReportData?.payable_basic_salary) || 0) +
  //   (parseFloat(payslipReportData?.ot_amount) || 0) +
  //   (parseFloat(payslipReportData?.bonus_amount) || 0) +
  //   (parseFloat(payslipReportData?.incentive_amount) || 0) +
  //   (parseFloat(payslipReportData?.gross_arrear) || 0) +
  //   (parseFloat(payslipReportData?.any_other_amt) || 0) +
  //   (payslipReportData?.allowance?.reduce(
  //     (sum, allowance) => sum + (parseFloat(allowance?.allowance_value) || 0),
  //     0
  //   ) || 0);

  // const totalEarningsYTD =
  //   (parseFloat(payslipReportData?.payable_basic_salary_YTD) || 0) +
  //   (parseFloat(payslipReportData?.ot_amount_YTD) || 0) +
  //   (parseFloat(payslipReportData?.bonus_amount_YTD) || 0) +
  //   (parseFloat(payslipReportData?.incentive_amount_YTD) || 0) +
  //   (parseFloat(payslipReportData?.gross_arrear) || 0) +
  //   (parseFloat(payslipReportData?.any_other_amt_YTD) || 0) +
  //   (payslipReportData?.allowances_YTD?.reduce(
  //     (sum, allowance) => sum + (parseFloat(allowance?.allowance_value_YTD) || 0),
  //     0
  //   ) || 0);

  // const totalDeductions =
  //   (parseFloat(payslipReportData?.epf_amount) || 0) +
  //   (parseFloat(payslipReportData?.esi_amount) || 0) +
  //   (parseFloat(payslipReportData?.pTaxAmount) || 0) +
  //   (parseFloat(payslipReportData?.canteen) || 0) +
  //   (parseFloat(payslipReportData?.tds) || 0) +
  //   (parseFloat(payslipReportData?.advance_amount) || 0) +
  //   (parseFloat(payslipReportData?.loan_advance) || 0) +
  //   (parseFloat(payslipReportData?.epf_arrear) || 0) +
  //   (parseFloat(payslipReportData?.esic_arrear) || 0) +
  //   (parseFloat(payslipReportData?.any_other_deduction) || 0);

  // const netSalary = totalEarnings - totalDeductions;
  logger.log("payslipReportData-vv", payslipReportData)
  return (
    <Document>
      <Page size="A4" orientation="portrait" style={reportStyles.page}>
        <ReportHeader1
          organization_info={payslipReportData?.organization_info}
        />
        <View
          style={[
            {
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            },
          ]}
        >
          <Text style={reportStyles.pdfHeaderTableHeading}>
            {payslipReportData?.employee_name
              ? payslipReportData?.employee_name
              : "N/A"}
          </Text>
          <Text style={reportStyles.pdfHeaderTableHeading}>
            Month of{" "}
            {dayjs(
              `${payslipReportData.year}-${payslipReportData.month}-01`
            ).format("MMMM, YYYY")}
          </Text>
        </View>
        <View style={reportStyles.pdfHeaderTable}>
          <View
            style={[
              reportStyles.pdfHeaderTableBx,
              reportStyles.RightBorder,
              reportStyles.PaddingRight,
            ]}
          >
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>Emp Code:</Text>
              <Text>{payslipReportData?.employee_code}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>Department:</Text>
              <Text>
                {payslipReportData?.employees?.department
                  ? payslipReportData?.employees?.department
                  : "--"}
              </Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>Designation:</Text>
              <Text>
                {payslipReportData?.employees?.designation
                  ? payslipReportData?.employees?.designation
                  : "--"}
              </Text>
            </View>
            {/* {payslipReportData?.} */}
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>DOJ:</Text>
              {/* <Text>{payslipReportData?.employees?.join_date}</Text> */}
              <Text>{payslipReportData?.employees?.join_date && formatToCustomDate(new Date(payslipReportData.employees.join_date))}</Text>
            </View>
          </View>
          <View
            style={[
              reportStyles.pdfHeaderTableBx,
              reportStyles.RightBorder,
              reportStyles.PaddingHorizontal,
            ]}
          >
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>PAN:</Text>
              <Text>
                {payslipReportData?.employees?.document_number
                  ? payslipReportData?.employees?.document_number
                  : "--"}
              </Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>UAN:</Text>
              <Text>
                {payslipReportData?.employees?.uan_no
                  ? payslipReportData?.employees?.uan_no
                  : "--"}
              </Text>
            </View>
            {!payslipReportData?.esi_amount === 0 &&
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text style={reportStyles.TextBold}>ESI No:</Text>
                <Text>
                  {payslipReportData?.employees?.esic_insurance_number
                    ? payslipReportData?.employees?.esic_insurance_number
                    : "--"}
                </Text>
              </View>}
            {payslipReportData?.employees?.epf_id_ac_no && (
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text style={reportStyles.TextBold}>PF Code:</Text>
                <Text>{payslipReportData?.employees?.epf_id_ac_no}</Text>
              </View>
            )}
          </View>

          <View
            style={[reportStyles.pdfHeaderTableBx, reportStyles.PaddingLeft]}
          >
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>Bank Name:</Text>
              <Text>
                {payslipReportData?.employees?.bank_name
                  ? payslipReportData?.employees?.bank_name
                  : "--"}
              </Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text
                style={[
                  reportStyles.TextBold,
                  {
                    overflowWrap: "break-word",
                  },
                ]}
              >
                Branch Name:
              </Text>
              <Text
                style={{
                  textAlign: "left",
                }}
                wrap
              >
                {payslipReportData?.employees?.branch_name}
              </Text>
            </View>

            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>A/C N0:</Text>
              <Text>
                {payslipReportData?.employees?.account_number
                  ? payslipReportData?.employees?.account_number
                  : "--"}
              </Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>IFSC Code:</Text>
              <Text>
                {payslipReportData?.employees?.ifsc_code
                  ? payslipReportData?.employees?.ifsc_code
                  : "--"}
              </Text>
            </View>
          </View>
        </View>
        {/* <View style={reportStyles.pdfHeaderTable}>
          <View
            style={[
              reportStyles.pdfHeaderTableBx,
              reportStyles.RightBorder,
              reportStyles.PaddingRight,
            ]}
          >
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>Month Days:</Text>
              <Text>{payslipReportData?.attendance_info?.month_days}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>Payable days:</Text>
              <Text>
                {payslipReportData?.payable_days}
              </Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>NCP days:</Text>
              <Text>
                {payslipReportData?.attendance_info?.ncp_days
                  ? payslipReportData?.attendance_info?.ncp_days
                  : 0}
              </Text>
            </View>
            {payslipReportData?.employees?.salary_type === "salary" &&
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text style={reportStyles.TextBold}>Weekly off:</Text>
                <Text>
                  {payslipReportData?.payable_days === 0 ? 0 : payslipReportData?.attendance_info?.total_weekly_off}
                </Text>
              </View>}
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>Holidays:</Text>
              <Text>
                {payslipReportData?.attendance_info?.declared_holiday}
              </Text>
            </View>
                        <View style={reportStyles.HeaderTableBxWrap}>
              <Text style={reportStyles.TextBold}>OT Hour:</Text>
              <Text>
                {convertMinutesToHours(payslipReportData?.attendance_info?.ot_hours)}
              </Text>
            </View>
          </View>


          <View
            style={[reportStyles.pdfHeaderTableBx, reportStyles.PaddingLeft]}
          >
                     {Array.isArray(payslipReportData?.leave_balances_infos) && payslipReportData?.leave_balances_infos?.map((item, index) => (
            <View style={reportStyles.HeaderTableBxWrap} key={index}>
              <Text style={reportStyles.TextBold}>{item?.leave_type} Balance:</Text>
              <Text>
              {item?.total_leaves}
              </Text>
            </View>))}
          </View>
        </View> */}

        <View style={reportStyles.pdfSummaryBox}>
          <View>
            <Text>Month Days</Text>
            <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
              {payslipReportData?.attendance_info?.month_days}
            </Text>
          </View>
          <View>
            <Text>Payable days</Text>
            <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
              {payslipReportData?.payable_days}
            </Text>
          </View>
          <View>
            <Text>NCP days</Text>
            <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
              {payslipReportData?.attendance_info?.ncp_days
                ? payslipReportData?.attendance_info?.ncp_days
                : 0}
            </Text>
          </View>
          {payslipReportData?.employees?.salary_type === "salary" &&
            <View>
              <Text>Weekly off</Text>
              <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
                {payslipReportData?.payable_days === 0 ? 0 : payslipReportData?.attendance_info?.total_weekly_off}
              </Text>
            </View>
          }
          <View>
            <Text>Holidays</Text>
            <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
              {payslipReportData?.attendance_info?.declared_holiday}
            </Text>
          </View>
          <View>
            <Text>Leave</Text>
            <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
              {payslipReportData?.attendance_info?.total_payable_leave}
            </Text>
          </View>
          {payslipReportData?.attendance_info?.ot_hours && (
            <View>
              <Text>OT Hour</Text>
              <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
                {convertMinutesToHours(payslipReportData?.attendance_info?.ot_hours)}
              </Text>
            </View>
          )}
        </View>

        {Array.isArray(payslipReportData?.leave_balances_infos) &&
          <View style={reportStyles.pdfSummaryBox}>
            {payslipReportData?.leave_balances_infos?.map((item, index) => (
              <View key={index}>
                <Text>{item?.leave_type} Balance</Text>
                <Text style={[reportStyles.TextBold, reportStyles.TextTwelve]}>
                  {item?.total_leaves}
                </Text>
              </View>
            ))}
          </View>
        }
        <View style={reportStyles.pdfSalaryOverview}>
          <View style={reportStyles.pdfSalaryInfo}>
            <View style={reportStyles.pdfSalaryOverviewHeading}>
              <Text>Earning</Text>
              <View
                style={[
                  reportStyles.pdfSalaryOverviewAmmount,
                  { fontSize: "10px" },
                ]}
              >
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>Monthly</Text> */}
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>YTD</Text> */}
              </View>
            </View>
            {payslipReportData?.payable_basic_salary && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Basic Salary</Text>
                <View style={reportStyles.pdfSalaryOverviewAmmount}>
                  <Text style={reportStyles.pdfSalaryOverviewValue}>
                    ₹{formatIndianCurrency(Number(payslipReportData?.payable_basic_salary ?? 0).toFixed())}
                  </Text>
                  {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{(payslipReportData?.payable_basic_salary_YTD ?? 0).toFixed()}</Text> */}
                </View>
              </View>
            )}

            {payslipReportData?.allowance?.length > 0 &&
              payslipReportData.allowance.map((allowance, index) => {
                // Find the corresponding YTD allowance value
                // const ytdAllowance = payslipReportData?.allowances_YTD?.find(
                //   (ytd) => ytd.allowance_name === allowance.allowance_name
                // );

                return (
                  <View
                    key={index}
                    style={reportStyles.pdfSalaryOverviewDetails}
                  >
                    <Text>{allowance?.allowance_name}</Text>
                    <View style={reportStyles.pdfSalaryOverviewAmmount}>
                      <Text style={reportStyles.pdfSalaryOverviewValue}>
                        ₹{formatIndianCurrency(Number(allowance?.allowance_value ?? 0).toFixed())}
                      </Text>
                      {/* <Text style={reportStyles.pdfSalaryOverviewValue}>
                        ₹{(ytdAllowance?.allowance_value_YTD ?? 0).toFixed())}
                      </Text> */}
                    </View>
                  </View>
                );
              })}
            {payslipReportData?.ot_amount &&
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>OT Amount</Text>
                <View style={reportStyles.pdfSalaryOverviewAmmount}>
                  <Text style={reportStyles.pdfSalaryOverviewValue}>
                    ₹{formatIndianCurrency(Number(payslipReportData?.ot_amount).toFixed())}
                  </Text>
                  {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{payslipReportData?.ot_amount_YTD}</Text> */}
                </View>
              </View>
            }
            {payslipReportData?.bonus_amount && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Bonus</Text>
                <View style={reportStyles.pdfSalaryOverviewDetails}>
                  <Text style={reportStyles.pdfSalaryOverviewValue}>
                    ₹{formatIndianCurrency(Number(payslipReportData?.bonus_amount).toFixed())}
                  </Text>
                  {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{payslipReportData?.bonus_amount_YTD}</Text> */}
                </View>
              </View>
            )}
            {payslipReportData?.incentive_amount && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Incentive</Text>
                <View style={reportStyles.pdfSalaryOverviewDetails}>
                  <Text style={reportStyles.pdfSalaryOverviewValue}>
                    ₹{formatIndianCurrency(Number(payslipReportData?.incentive_amount).toFixed())}
                  </Text>
                  {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{payslipReportData?.incentive_amount_YTD}</Text> */}
                </View>
              </View>
            )}

            {payslipReportData?.any_other_amt && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Other Earnings</Text>
                <View style={reportStyles.pdfSalaryOverviewDetails}>
                  <Text style={reportStyles.pdfSalaryOverviewValue}>
                    ₹{formatIndianCurrency(Number(payslipReportData?.any_other_amt).toFixed())}
                  </Text>
                  {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{payslipReportData?.any_other_amt_YTD}</Text> */}
                </View>
              </View>
            )}
            {payslipReportData?.gross_arrear && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Gross Arrear</Text>
                <Text>₹{formatIndianCurrency(Number(payslipReportData?.gross_arrear).toFixed())}</Text>
              </View>
            )}
            <View style={reportStyles.pdfSalaryOverviewFooter}>
              <Text>Total Earning </Text>
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text style={reportStyles.pdfSalaryOverviewValue}>
                  {/* ₹{totalEarnings.toFixed())} */}
                  ₹{formatIndianCurrency(Number(payslipReportData?.gross_salary).toFixed())}
                </Text>
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{totalEarningsYTD.toFixed())}</Text> */}
              </View>
            </View>
          </View>
          <View style={reportStyles.pdfSalaryInfo}>
            <View style={reportStyles.pdfSalaryOverviewHeading}>
              <Text>Deduction</Text>
              <View
                style={[
                  reportStyles.pdfSalaryOverviewAmmount,
                  { fontSize: "10px" },
                ]}
              >
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>Monthly</Text> */}
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>YTD</Text> */}
              </View>
            </View>
            <View style={reportStyles.pdfSalaryOverviewDetails}>
              <Text>EPF Contribution</Text>
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text style={reportStyles.pdfSalaryOverviewValue}>
                  ₹{formatIndianCurrency(Number(payslipReportData?.epf_amount ?? 0).toFixed())}
                </Text>
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{(payslipReportData?.epf_amount_YTD ?? 0).toFixed())}</Text> */}
              </View>
            </View>
            <View style={reportStyles.pdfSalaryOverviewDetails}>
              <Text>ESI Contribution</Text>
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text style={reportStyles.pdfSalaryOverviewValue}>
                  ₹{formatIndianCurrency(Number(payslipReportData?.esi_amount ?? 0).toFixed())}
                </Text>
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{(payslipReportData?.esi_amount_YTD ?? 0).toFixed())}</Text> */}
              </View>
            </View>
            <View style={reportStyles.pdfSalaryOverviewDetails}>
              <Text>P-Tax</Text>
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text style={reportStyles.pdfSalaryOverviewValue}>
                  ₹{formatIndianCurrency(Number(payslipReportData?.pTaxAmount ?? 0).toFixed())}
                </Text>
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{(payslipReportData?.pTaxAmount_YTD ?? 0).toFixed())}</Text> */}
              </View>
            </View>

            {!payslipReportData?.labour_welfare == 0 && 
            <View style={reportStyles.pdfSalaryOverviewDetails}>
              <Text>Labour Welfare Fund</Text>
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text style={reportStyles.pdfSalaryOverviewValue}>
                  ₹{formatIndianCurrency(Number(payslipReportData?.labour_welfare ?? 0).toFixed())}
                </Text>
              </View>
            </View>
            }


            {payslipReportData?.canteen && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Canteen</Text>
                <View style={reportStyles.pdfSalaryOverviewDetails}>
                  <Text style={reportStyles.pdfSalaryOverviewValue}>
                    ₹{formatIndianCurrency(Number(payslipReportData?.canteen).toFixed())}
                  </Text>
                  {/* <Text style={reportStyles.pdfSalaryOverviewValue}>₹{payslipReportData?.canteen_YTD}</Text> */}
                </View>
              </View>
            )}
            {payslipReportData?.tds && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>TDS</Text>
                <Text>₹{formatIndianCurrency(Number(payslipReportData?.tds).toFixed())}</Text>
              </View>
            )}
            {payslipReportData?.advance_amount && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Advance Amount</Text>
                <Text>₹{formatIndianCurrency(Number(payslipReportData?.advance_amount).toFixed())}</Text>
              </View>
            )}
            {payslipReportData?.loan_advance && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Loan EMI</Text>
                <Text>₹{formatIndianCurrency(Number(payslipReportData?.loan_advance).toFixed())}</Text>
              </View>
            )}
            {payslipReportData?.epf_arrear && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>EPF Arrear</Text>
                <Text>₹{formatIndianCurrency(Number(payslipReportData?.epf_arrear).toFixed())}</Text>
              </View>
            )}
            {payslipReportData?.esic_arrear && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>ESI Arrear</Text>
                <Text>₹{formatIndianCurrency(Number(payslipReportData?.esic_arrear).toFixed())}</Text>
              </View>
            )}
            {payslipReportData?.any_other_deduction && (
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text>Other Deduction</Text>
                <Text>₹{formatIndianCurrency(Number(payslipReportData?.any_other_deduction).toFixed())}</Text>
              </View>
            )}
            <View style={reportStyles.pdfSalaryOverviewFooter}>
              <Text>Total Deduction</Text>
              {/* <Text>₹ {parseFloat(payslipReportData?.total_deduction || 0).toFixed(2)}</Text> */}
              <View style={reportStyles.pdfSalaryOverviewDetails}>
                <Text style={reportStyles.pdfSalaryOverviewValue}>
                  {/* ₹{totalDeductions.toFixed(2)} */}
                  ₹{formatIndianCurrency(Number(payslipReportData?.total_deduction).toFixed())}
                </Text>
                {/* <Text style={reportStyles.pdfSalaryOverviewValue}></Text> */}
              </View>
            </View>
          </View>
        </View>
        <View style={reportStyles.pdfSalaryTotal}>
          <View>
            <Text style={[reportStyles.TextPrimary, reportStyles.TextBold]}>
              Net Payable Salary
            </Text>
            <Text
              style={[
                reportStyles.TextGrey,
                reportStyles.TextNine,
                { textTransform: "capitalize" },
              ]}
            >
              In words: {numberToWords(Math.round(payslipReportData?.payable_salary))}
            </Text>
          </View>
          <Text
            style={[
              reportStyles.TextPrimary,
              reportStyles.TextBold,
              { textAlign: "right" },
            ]}
          >
            {/* ₹ {netSalary.toFixed(2)} */}
            ₹{formatIndianCurrency(Math.round(Number(payslipReportData?.payable_salary)))}
          </Text>
          {/* <View style={{ textAlign: "right" }}>
          <Text
              style={[
                reportStyles.TextGrey,
                reportStyles.TextTen,
                reportStyles.TextBold,
              ]}
            >
              (Round off: ₹{Math.round(payslipReportData?.payable_salary)} )
            </Text>
          </View> */}
        </View>
        <Text
          style={[
            reportStyles.TextGrey,
            reportStyles.TextNine,
            { textTransform: "capitalize", textAlign: "center" },
          ]}
        >
          “NB: This is a computer-generated payslip and does not require a signature or stamp.”
        </Text>
        {/* <Text
          style={[
            reportStyles.TextGrey,
            reportStyles.TextNine,
            { textTransform: "capitalize" },
          ]}
        >
          IP address: {ipAddress || "..."}{" "}
        </Text> */}
        <View style={reportStyles.footer} fixed>
          <Text  >Download  Date & Time: {dayjs().format("DD-MM-YYYY hh:mm A")} </Text>
          <Text render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )} />
        </View>
      </Page>
    </Document>
  );
};

export default PayslipPdf;
